<template>
    <div>
        <div class="columns is-multiline">
            <div class="column is-full ">
                <b-field label="Clasificado"
                message="Usar si este producto es un inmueble o un vehiculo">
                    <b-switch
                    v-on:input="dispatchChange"
                    v-model="productData.classified">
                    </b-switch>
                </b-field>
            </div>
            <div class="column is-full ">
                <b-field label="Tiene demoras"
                message="Usar si este producto no esta en stock, o es traido de afuera">
                    <b-switch
                    v-on:input="dispatchChange"
                    v-model="productData.hasDelay">
                    </b-switch>
                </b-field>
                
            </div>
        </div>
        <div class="columns is-multiline">
            <div class="column is-one-third">
                <b-field label="Titulo">
                    <b-input 
                        type="text"
                        value=""
                        maxlength="60"
                        required
                        v-model="productData.title"
                        v-on:input="dispatchChange">
                    </b-input>
                </b-field>
            </div>

            <div class="column is-one-third">
                <b-field label="Estado">
                    <b-select v-on:input="dispatchChange" v-model="productData.status"  :icon="statusIcon" required expanded>
                        <option value="">---------</b-icon></option>
                        <option value="P">Publico </option>
                        <option value="H">Escondido </option>
                        <option value="O">De oferta </option>
                    </b-select>
                </b-field>
            </div>
            
            <div class="column is-one-third">
                <b-field label="Codigo">
                    <b-input
                    v-model="productData.code"
                    max="30">
                    </b-input>
                </b-field>
            </div>
            
            <div class="column is-one-third">
                <b-field label="Peso (kg)">
                    <b-numberinput
                    min="0"
                    step="0.01"
                    :controls="false"
                    v-model="productData.weightKg"
                    v-on:input="dispatchChange">
                    </b-numberinput>
                </b-field>
            </div>
            <div class="column is-two-thirds">
                <b-field label="Garantia">
                    <b-input
                    v-model="productData.warranty"
                    max="200"
                    >
                    </b-input>
                </b-field>
            </div>

        </div>

        <div class="columns">
            <div class="column is-two-thirds ">
                
                <b-field label="Descripcion">
                    <quillEditor
                    class="editor"
                    ref="myTextEditor"
                    :value="productData.description"
                    :options="editorOption"
                    @change="dispatchChangeFromEditor"/>
                </b-field>
            
            </div>
        </div>

        <div class="columns">
            <div class="column">
                <b-field label="Seccion/Categoria">
                   <b-autocomplete
                    v-model="searchSub"
                    icon="search"
                    :data="subcategories"
                    field="title"
                    :loading = "loadingSub"
                    @input="fetchSubcategories"
                    @select="option => {
                        productData.subcategory = option.id
                        productData.filterOptions = []
                        searchSub = option.title
                        updateData
                        }"
                    >
                    <template slot-scope="props">
                    <p>{{props.option.categoryTitle}} / {{props.option.title}}</p>
                    </template>
                    <template slot="empty">No section found. Add new section</template>
                    </b-autocomplete>
                </b-field>
            </div>
        </div>

        <div class="columns m-t-20">
            <div class="column is-flex">
                <h2 class="has-text-weight-medium is-size-4">Pricing. </h2>
               
                <b-select  
                    v-on:input="dispatchChange" 
                    v-model="productData.currency" 
                    placeholder="Select a Currency" 
                    icon="dollar-sign" 
                    required 
                    class="m-l-20"
                    :loading="loadingCurrencies">
                    <option value="">---------</option>
                    <option 
                        v-for="x in currencies" 
                        :key="x.id"
                        :value="x.id">
                            {{x.title}} {{x.symbol}}
                    </option>
                </b-select>
               
            </div>
        </div>

        <div class="columns">
            <div class="column is-half">
                <b-field label="Precio de venta">
                    <b-numberinput 
                    type="is-light" 
                    v-on:input="dispatchChange" 
                    v-model="productData.price" 
                    min="0" 
                    controls-rounded>
                    </b-numberinput>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Comparar a">
                    <b-numberinput  
                    type="is-light"
                    v-on:input="dispatchChange" 
                    v-model="productData.compareAt" 
                    min="0" 
                    controls-rounded>
                    </b-numberinput>
                </b-field>
            </div>
        </div>

        <div class="columns">
            <div class="column is-half">
                <b-field label="Impuesto de venta">
                    <b-select :loading="loadingTaxes" v-on:input="dispatchChange" v-model="productData.tax" expanded placeholder="Tax" icon="percentage" >
                        <option value="">---------</option>
                        <option v-for="x in taxes" :key="x.id" :value="x.id">{{x.title}} - %{{x.percentage}}</option>
                    </b-select>
                </b-field>
            </div>
            <div class="column is-half">
                <b-field label="Costo">
                    <b-numberinput 
                    type="is-light"
                    v-on:input="dispatchChange" 
                    v-model="productData.cost" 
                    min="0" 
                    controls-rounded>
                    </b-numberinput>
                </b-field>
            </div>
        </div>
        <div v-if="filtersOptions.length" class="columns is-multiline">
            <div class="column is-full">
                <p class="title">Filtros</p>
            </div>
            <div v-for="x in filtersOptions" :key="x.id" class="column is-one-third">
                <p class="has-text-weight-bold m-b-5">
                    {{x.title}}
                </p>
                
                <b-checkbox 
                    v-for="opt in x.options" 
                    :key="opt.id"
                    size="is-small"
                    v-on:input="dispatchChange" 
                    v-model="productData.filterOptions"
                    :native-value="opt.id">
                    {{opt.title}}
                </b-checkbox>
                
            </div>
        </div>


    </div>
</template>

<script>
import {getHandler, debounce} from "./../../../../services/http.js";
import { quillEditor } from 'vue-quill-editor'
import {mapGetters} from 'vuex';

export default {
    name: "ProductForm",
    components:{
        quillEditor
    },
    props:{
        currencyEndpoint:{
            type:String,
            default:""
        },
        taxEndpoint:{
            type:String,
            default:""
        },
        subcategoryEndpoint:{
            type:String,
            default:""
        },
        filtersOptions:{
            type: Array,
            default: new Array([])
        }
    },
    data(){
        return{
            productData:{
                title:"",
                status:"",
                description:"",
                subcategory:"",
                currency:"",
                tax:"",
                price:0,
                cost:0,
                compareAt:0,
                classified:false,
                hasDelay:false,
                weightKg:0.00,
                warranty:"",
                filterOptions:[]
            },
            currencies: [],
            loadingCurrencies:false,
            taxes:[],
            loadingTaxes:false,
            loadingSub:false,
            searchSub:"",
            subcategories:[],
            editorOption: {
                modules: {
                    toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],
                    ['blockquote', 'code-block'],
                    [{ 'header': 1 }, { 'header': 2 }],
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],
                    [{ 'indent': '-1' }, { 'indent': '+1' }],
                    [{ 'direction': 'rtl' }],
                    [{ 'size': ['small', false, 'large', 'huge'] }],
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
                    [{ 'font': [] }],
                    [{ 'color': [] }, { 'background': [] }],
                    [{ 'align': [] }],
                    ['clean'],
                    ['link', 'video']
                    ],
                }
            },   
        }
    },
    methods:{
        dispatchChangeFromEditor(value){
            console.log(value)
            this.productData.description = value.html
            this.$store.dispatch('updateData', {obj:'productData', data:this.productData})
        },
        dispatchChange(){
            this.$store.dispatch('updateData', {obj:'productData', data:this.productData})
        },
        async fetchCurrencies(){
            this.loadingCurrencies = true
            var response = await getHandler(this.currencyEndpoint, {error:false, success:false})
            this.currencies = response
            this.loadingCurrencies = false
        },
        async fetchTaxes(){
            this.loadingTaxes = true
            var response = await getHandler(this.taxEndpoint, {error:false, success:false})
            this.taxes = response
            this.loadingTaxes = false
        },
        fetchSubcategories: debounce( async function (){
            this.loadingSub = true
            let url = `${this.subcategoryEndpoint}?name=${this.searchSub}`
            var response = await getHandler(url, {error:false, success:false})
            this.subcategories = response.results
            this.loadingSub = false
        }, 250),
    },
    computed:{
        ...mapGetters(['getAllFilters']),
        filtersOptions(){
            var accurate = this.getAllFilters.filter((el)=>{
                if (el.category == null){
                    return !el.category
                } else if (el.category == this.productData.category && this.productData.subcategory == null){
                    return el.category == this.productData.category && this.productData.subcategory == null
                } else if (el.subcategory == this.productData.subcategory){
                    return el.subcategory == this.productData.subcategory
                }
            })
            return accurate
        },
        statusIcon(){
            let icon = "times"
            switch(this.productData.status){
                case "P":
                    icon = "eye";
                    break;
                case "O":
                    icon = "tag";
                    break;
                case "H":
                    icon = "eye-slash";
                    break;
            }
            return icon
        }
    },
    created(){
        this.fetchCurrencies()
        this.fetchTaxes()
    }
    
}
</script>
